<div class="inner-card-header">
  <div class="d-flex align-items-center">
    <h3 class="card-title">
      {{ title | translate }}
    </h3>
    <button
      mat-icon-button
      type="button"
      *ngIf="!tempNew && !tempEditnewCreateItem && !isAnonymized"
      (click)="createNew()"
      class="cursor-pointer add-icon p-btn-primary smaler-size-btn">
      <mat-icon>add</mat-icon>
    </button>
    <button
      mat-icon-button
      type="button"
      *ngIf="tempNew && !isAnonymized"
      (click)="closeCreatenew()"
      class="cursor-pointer add-icon p-btn-primary smaler-size-btn">
      <mat-icon>close</mat-icon>
    </button>
  </div>
</div>
<div [formGroup]="currentForm">
  <div *ngIf="tempNew" class="inner-card-section new-item">
    <div class="d-flex flex-column w-100">
      <div *ngFor="let setting of fieldSettings">
        @if (setting.type === 'string') {
        <div class="d-flex w-100">
          <p class="rightHeadings">{{ setting.label | translate }}</p>
          @if(required){
          <span class="text-danger">*</span>
          }
        </div>
        <mat-form-field appearance="outline" class="small w-100">
          <input [formControlName]="setting.name" matInput matNativeControl placeholder="{{ setting.placeholder | translate }}" />
        </mat-form-field>
        } @if (setting.type === 'date') {
        <div class="d-flex w-100">
          <p class="rightHeadings">{{ setting.label | translate }}</p>
          <span class="text-danger">*</span>
        </div>
        <mat-form-field appearance="outline" class="small w-100">
          <input [matDatepicker]="dp1" [formControlName]="setting.name" placeholder="{{ 'stepperForm.examplePlaceHolders.birthDate' | translate }}" matInput />
          <mat-datepicker-toggle [for]="dp1" matSuffix></mat-datepicker-toggle>
          <mat-datepicker #dp1 panelClass="example-month-picker"></mat-datepicker>
        </mat-form-field>
        } @if (setting.type === 'select') {
        <div class="d-flex w-100">
          <p class="rightHeadings">{{ setting.label | translate }}</p>
        </div>
        <mat-form-field appearance="outline" class="small w-100">
          <mat-select [formControlName]="setting.name" matNativeControl>
            @for (level of allCVOptionsFromDB?.educationLevels; track level.id) {
            <mat-option [value]="level.id">
              {{ 'jobEducationLevels.' + level.educationKey | translate }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
        } @if (setting.type === 'html') {
        <div class="d-flex w-100">
          <p class="rightHeadings">{{ setting.label | translate }}</p>
        </div>
        <div class="rich-text-content w-100">
          <div class="NgxEditor__Wrapper">
            <ngx-editor-menu [editor]="descriptionEditor" [toolbar]="toolbar"></ngx-editor-menu>
            <ngx-editor [editor]="descriptionEditor" [formControlName]="setting.name" [placeholder]="setting.placeholder | translate"></ngx-editor>
          </div>
        </div>
        } @if (setting.name === 'current') {
        <div class="d-flex align-start ml-3">
          <mat-slide-toggle formControlName="current" class="cursor-pointer">
            {{ 'dashboard.candidateDetail.currentlyStudying' | translate }}
          </mat-slide-toggle>
        </div>
        }
      </div>
      <card-item-attachemnts [type]="current" [form]="currentForm" [edit]="true" [temNew]="true"></card-item-attachemnts>
    </div>
    <div class="new-item-nav mt-1 mb-1 d-flex justify-content-evenly">
      <button mat-flat-button type="button" (click)="closeCreatenew()" class="p-btn-light">
        {{ 'shared.close' | translate }}
      </button>
      <button mat-flat-button type="button" (click)="saveNew()" [disabled]="!currentForm?.valid" class="p-btn-primary">
        {{ 'shared.save' | translate }}
      </button>
    </div>
  </div>

  <div class="expansion-content">
    <mat-accordion class="w-100" [multi]="!edit ? true : false">
      <mat-expansion-panel *ngFor="let item of items; let i = index" #panel [hideToggle]="true">
        <mat-expansion-panel-header
          [ngStyle]="{ cursor: !edit ? 'pointer' : 'default' }"
          #panelHa
          (click)="panelHa._toggle()"
          [ngClass]="{ 'border-bottom': edit }">
          <mat-panel-title>
            <span *ngIf="edit" class="w-100 line-clamp" [matTooltip]="item[fieldSettings[0].name]">{{ item[fieldSettings[0].name] }}</span>
            <span *ngIf="!edit" (click)="panelHa._toggle()" class="w-100 line-clamp" [matTooltip]="item[fieldSettings[0].name]">
              {{ item[fieldSettings[0].name] }}
            </span>
          </mat-panel-title>
          <mat-panel-description class="d-flex justify-content-end" [ngStyle]="{ 'margin-right': !edit ? '.5rem' : '0' }">
            <span *ngIf="!edit" (click)="panelHa._toggle()" class="w-100 text-right">
              {{ item.startDate | date : 'shortDate' }} - {{ item.current || item.endDate === null ? 'curent' : (item.endDate | date : 'shortDate') }}
            </span>
            <div class="d-flex pe-2">
              @if ((!edit || step !== i) && !isAnonymized) {
              <button (click)="editItem(i, panel)" mat-icon-button type="button" class="mat-icon-edit" [ngStyle]="{ cursor: !edit ? 'pointer' : 'default' }">
                <mat-icon matTooltip="{{ 'shared.edit' | translate }}">edit</mat-icon>
              </button>
              } @if (edit && step === i && !isAnonymized) {
              <button mat-icon-button type="button" class="mat-icon-edit" (click)="removeItem(i, panel)">
                <mat-icon matTooltip="{{ 'dashboardSettings.userManagement.delete' | translate }}" class="danger">delete_forever</mat-icon>
              </button>
              <button mat-icon-button type="button" class="mat-icon-edit" (click)="saveEditItem(i, panel)">
                <mat-icon matTooltip="{{ 'shared.save' | translate }}">save</mat-icon>
              </button>
              <button mat-icon-button type="button" class="mat-icon-edit" (click)="closeEditItem(i, panel)">
                <mat-icon matTooltip="{{ 'shared.cancel' | translate }}" class="danger">cancel</mat-icon>
              </button>
              }
            </div>
          </mat-panel-description>
        </mat-expansion-panel-header>

        <div *ngFor="let setting of fieldSettings" class="pt-3">
          <div *ngIf="setting.type === 'string'" class="d-flex align-start flex-column ml-3">
            <div *ngIf="!edit" class="d-flex w-100">
              <p>{{ setting.label | translate }}:</p>
              <span>{{ item[setting.name] }}</span>
            </div>
            @if (edit) {
            <div class="d-flex w-100">
              <p class="rightHeadings">{{ setting.label | translate }}</p>
              <span class="text-danger">*</span>
            </div>
            <mat-form-field appearance="outline" class="small w-100">
              <input [formControlName]="setting.name" matInput matNativeControl placeholder="{{ setting.placeholder | translate }}" />
            </mat-form-field>
            }
          </div>

          <div *ngIf="setting.type === 'select'" class="d-flex align-start flex-column ml-3">
            <div *ngIf="!edit" class="d-flex w-100">
              <p>{{ setting.label | translate }}:</p>
              <span>
                @if (item[setting.name] && allCVOptionsFromDB?.educationLevels) {
                  @for (level of allCVOptionsFromDB.educationLevels; track level.id) {
                    @if (level.id === item[setting.name]) {
                      {{ 'jobEducationLevels.' + level.educationKey | translate }}
                    }
                  }
                }
              </span>
            </div>
            @if (edit) {
            <div class="d-flex w-100">
              <p class="rightHeadings">{{ setting.label | translate }}</p>
            </div>
            <mat-form-field appearance="outline" class="small w-100">
              <mat-select [formControlName]="setting.name" matNativeControl>
                @for (level of allCVOptionsFromDB?.educationLevels; track level.id) {
                <mat-option [value]="level.id">
                  {{ 'jobEducationLevels.' + level.educationKey | translate }}
                </mat-option>
                }
              </mat-select>
            </mat-form-field>
            }
          </div>

          <div *ngIf="setting.name === 'current'" class="d-flex align-start ml-3">
            <div class="d-flex align-start ml-3" *ngIf="!edit">
              <div *ngIf="!edit" class="d-flex w-100">
                <p>{{ 'dashboard.candidateDetail.currentlyStudying' | translate }}:</p>
                <span *ngIf="item.current">{{ 'shared.yes' | translate }}</span>
                <span *ngIf="!item.current">{{ 'shared.no' | translate }}</span>
              </div>
            </div>
            <mat-slide-toggle *ngIf="edit" formControlName="current" class="cursor-pointer">
              {{ 'dashboard.candidateDetail.currentlyStudying' | translate }}
            </mat-slide-toggle>
          </div>

          <div *ngIf="setting.type === 'date'" class="d-flex flex-column align-start ml-3">
            <div *ngIf="!edit && !(setting.name === 'endDate' && item.current)" class="d-flex w-100">
              <p>{{ setting.label | translate }}:</p>
              <span>{{ item[setting.name] !== null ? (item[setting.name] | date : 'dd.MM.yyyy') : '' }}</span>
            </div>
            @if (edit) {
            <div class="d-flex w-100">
              <p class="rightHeadings">
                {{ setting.label | translate }}
              </p>
              <span class="text-danger">*</span>
            </div>
            <mat-form-field appearance="outline" class="small w-100">
              <input
                [matDatepicker]="dp1"
                [formControlName]="setting.name"
                placeholder="{{ 'stepperForm.examplePlaceHolders.birthDate' | translate }}"
                matInput />
              <mat-datepicker-toggle [for]="dp1" matSuffix></mat-datepicker-toggle>
              <mat-datepicker #dp1 panelClass="example-month-picker"></mat-datepicker>
            </mat-form-field>
            }
          </div>

          <div *ngIf="setting.type === 'html'" class="d-flex flex-column align-start ml-3">
            <div *ngIf="!edit" class="d-flex flex-column w-100">
              <p>{{ setting.label | translate }}:</p>
              <div class="w-100" [innerHTML]="item[setting.name]"></div>
            </div>
            @if (edit) {
            <div class="d-flex w-100">
              <p class="rightHeadings">{{ setting.label | translate }}</p>
            </div>
            <div class="rich-text-content w-100">
              <div class="NgxEditor__Wrapper">
                <ngx-editor-menu [editor]="descriptionEditor" [toolbar]="toolbar"></ngx-editor-menu>
                <ngx-editor [editor]="descriptionEditor" [formControlName]="setting.name" [placeholder]="setting.placeholder | translate"></ngx-editor>
              </div>
            </div>
            }
          </div>
        </div>
        <card-item-attachemnts [type]="current" [form]="currentForm" [edit]="edit" [item]="item.candidateAttachment"></card-item-attachemnts>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</div>
